import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'BrandNpmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-npm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M1 8h22v7h-12v2h-4v-2h-6z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 8v7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 8v7"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 11v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 11v4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M11 11v1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 11v4"
    }, null), _createTextVNode(" ")]);
  }
};